import React from 'react'
import './Style/Info.css'
function Info({data}) {
  return<div>
    <div className='invoice-info'>
          <div className='ship-to'>
            <h2> Ship To: </h2>
            <p> {data.shipto.companyName} </p>
            <p> {data.shipto.streetAddress} </p>
            <p> {data.shipto.city} </p>
          </div>

          <div className='bill-to'>
            <h2> Bill To: </h2>
            <p> {data.billTo.companyName} </p>
            <p> {data.billTo.streetAddress} </p>
            <p> {data.billTo.city} </p>
          </div>

          <div className='payment'>
            <h2> Payment: </h2>
            <p> {data.payment.bankAccount} </p>
            <p> {data.payment.bankName} </p>
            <p> {data.payment.bankCode} </p>
          </div>
    </div>
    <h1 className='paypal'> Paypal </h1>
    <p className='paypal-account'> {data.Paypal.paypalAccount} </p>
  </div>
}

export default Info